// Third-party
import React from 'react';

// Components
import SegmentedControl from '../navigation/SegmentedControl';
import ControlItem from '../navigation/ControlItem';
import { Tooltip } from '../tooltips';

// Utils
import { FormattedMessage, formatMessage } from '@/utils/i18n';
import { TIME_PERIODS } from '@/utils/constants';
import Nullable from '@/types/nullable';
import Locale from '@/types/locale';

type Props = {
  selected: Nullable<TIME_PERIODS>;
  onChange?: (value: TIME_PERIODS) => void;
  dark?: boolean;
  className?: string;
  values: TIME_PERIODS[];
  locale?: Locale;
  darkerBackground?: boolean;
};

const TOOLTIP_I18N_KEYS: Partial<Record<TIME_PERIODS, string>> = {
  [TIME_PERIODS.INC]: 'Common.Toolbar.SinceInceptionTooltip',
  [TIME_PERIODS.CI]: 'Common.Toolbar.CommonInceptionTooltip',
};

const getTooltipMessage = (value: TIME_PERIODS) => {
  const key = TOOLTIP_I18N_KEYS[value];
  return key && formatMessage(key);
};

/**
 * Component to select different time ranges
 * @param {Function} onChange Gets called when a value change, first param is the number of months selected
 */
const DateQuickRangeOneWay = ({ className, selected, onChange, dark, values, locale, darkerBackground }: Props) => (
  <SegmentedControl className={className} selected={selected} onChange={onChange} dark={dark} darkerBackground={darkerBackground} role="radiogroup">
    {values.map(value => (
      <ControlItem value={value} key={value} aria-checked={selected === value} role="radio">
        <Tooltip className="ms-0 inception-tooltip" message={getTooltipMessage(value)} disabled={!getTooltipMessage(value)} data-private data-dd-privacy="mask">
          <div>
            <FormattedMessage id={`Charts.Growth.Dates.${value}`} locale={locale} />
          </div>
        </Tooltip>
      </ControlItem>
    ))}
  </SegmentedControl>
);

export default DateQuickRangeOneWay;
